/** Refresh shared data while visible; defer reads until optimistic writes settle. */
export function sharedSyncOptions(pendingWrites: number) {
  return {
    enabled: pendingWrites === 0,
    staleTime: 0,
    refetchInterval: 5_000,
    refetchIntervalInBackground: false,
    refetchOnWindowFocus: true,
    refetchOnReconnect: true,
  } as const;
}
